import React from "react";
import PageHeader from "../components/PageHeader";

export default function EducationGuidelines() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Documents", link: "/documents" },
    { label: "Education Guidelines", active: true },
  ];

  const documents = [
    {
      title: "GUIDELINES ON SCHOOL SAFETY AND SECURITY",
      size: "2.80 MB",
      date: "01-07-25",
      link: "#",
    },
    {
      title: "PREVENTING BULLYING AND CYBERBULLYING GUIDELINES FOR SCHOOLS 2024",
      size: "25.60 MB",
      date: "29-04-24",
      link: "#",
    },
    {
      title: "GUIDELINES FOR SCHOOLS ON PREVENTING BULLYING AND CYBER BULLYING",
      size: "25.66 MB",
      date: "14-12-23",
      link: "#",
    },
    {
      title: "REGULATORY GUIDELINES FOR HOSTEL OF EDUCATIONAL INSTITUTIONS FOR CHILDREN",
      size: "7.38 MB",
      date: "17-02-23",
      link: "#",
    },
    {
      title: "REGULATORY GUIDELINES FOR PRIVATE PLAY SCHOOLS",
      size: "85.47 KB",
      date: "11-07-22",
      link: "#",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="Education Guidelines (NCPCR, Govt. of India)"
        breadcrumbs={breadcrumbs}
      />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">
            Education Guidelines
          </h2>

          <div className="position-relative">
            {/* Center vertical line */}
            <div
              className="position-absolute top-0 start-50 translate-middle-x bg-primary"
              style={{ width: "4px", height: "100%", borderRadius: "2px" }}
            ></div>

            {/* Timeline items */}
            <div className="timeline position-relative">
              {documents.map((doc, index) => (
                <div
                  key={index}
                  className={`row g-0 mb-5 align-items-center ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="card shadow-sm p-4 rounded-4 border-0 timeline-card">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary rounded-pill">
                          {index + 1}
                        </span>
                        <small className="text-muted">{doc.date}</small>
                      </div>
                      <h5 className="text-primary fw-bold mb-2">{doc.title}</h5>
                      <p className="text-secondary mb-3">{doc.size}</p>
                      <a
                        href={doc.link}
                        className="btn btn-outline-primary rounded-pill"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
